/**
 * stanford_ats.js — Aster (Research Paper / Academic Serif)
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Bible:
 *   Brand Name:   Aster
 *   Purpose:      Academic & Legal Excellence
 *   Reads Like:   Published Ivy League Research Paper / Thesis
 *   Emotion:      Calm, Trust, Authority, Prestige
 *   Personality:  Calm
 *   Reading Speed: Slow, linear
 *   Scanning:     Top Center ↓ (vertical column scan)
 *   Hero Moment:  Academic Masthead Header (Centered, Times New Roman, stacked byline meta)
 *   ATS Target:   High ATS Compatibility (Single-column, zero layout tricks)
 *
 * Forbidden Elements:
 *   ✗ Sidebars, columns, or layout splits
 *   ✗ Icons, tags, capsules, or badge grids
 *   ✗ Bordered cards or cards grids
 *   ✗ Monospace text or neon colors
 */

export const stanford_ats = {
  id: 'stanford-ats',
  version: 3,
  renderer: 'enterprise',
  name: 'Aster',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'luxury',
  sectionDividerStyle: 'dots',
  // Narrative Shift: Publications and Education lead before Experience to project academic credentials first
  sectionOrder: ['personal-info', 'publications', 'education', 'experience', 'skills', 'certifications', 'achievements', 'summary'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-classic',
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['publications', 'education', 'experience', 'skills', 'certifications', 'achievements', 'summary'],
      },
      overrides: {
        '--font-family-primary': '"Times New Roman", "Georgia", Times, serif',
        '--font-family-secondary': '"Times New Roman", "Georgia", Times, serif',
        '--color-primary': '#8B0000', // Cardinal Red
        '--color-secondary': '#6B0000',
        '--color-accent': '#8B0000',
        '--color-text-main': '#111111',
        '--color-text-light': '#555555',
        '--color-border': '#C0A080',
        '--color-bg-page': '#FFFEF8', // Warm off-white paper
        '--spacing-margin': '36px',
        '--spacing-section-mb': '24px',
        '--spacing-item-mb': '16px',
        '--spacing-bullet-gap': '6px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '700',
    '--heading-weight': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--border-thickness-heading': '0',
    '--bullet-style': 'disc',
    '--font-size-heading': '9pt',
    '--font-size-body': '9.5pt',
    '--font-size-bullet': '9.2pt',
    '--line-height-body': '1.65',
  },
};

export default stanford_ats;
